/* eslint-disable camelcase */
import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { addAccessorial, AddAccessorialApiParameters } from "@tKgpco/Services/AccessorialsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { Accessorials } from "@tKgpco/Store/Data/Accessorials/AccessorialsState";

type Parameters = AddAccessorialApiParameters & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, Accessorials>;

export const PopulateApiParameters: HandlerType = props => {
    const { TI_Code, TI_Description, Enabled, Master, Name, Type, CarrierNoteOnly, CarrierNotes } = props.parameter;
    props.apiParameter = {
        TI_Code,
        TI_Description,
        Enabled,
        Master,
        Name,
        Type,
        CarrierNoteOnly,
        CarrierNotes,
    };
};

export const CreateAccessorial: HandlerType = async props => {
    try {
        await addAccessorial(props.parameter);
    } catch (error) {
        if (isApiError(error) && (error.status === 400 || error.status === 409)) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccess: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameters, CreateAccessorial, ExecuteOnSuccess];

const addNewAccessorial = createHandlerChainRunner(chain, "AddNewAccessorial");
export default addNewAccessorial;
